<template>
  <b-modal v-model="visible" :title="modalTitle" @ok="onOk" @show="onShow">
    <b-form @submit.prevent="onSubmit">
      <b-form-group class="required" label="Tytuł">
        <b-form-input
          v-model="title"
          :state="$v.title.$error? false : null"
          @input="$v.title.$reset()"
          type="text"
          autocomplete="off"
        />
        <b-form-invalid-feedback>
          <div v-if="!$v.title.required">To pole jest wymagane</div>
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group class="required" label="Dziedzina">
        <b-form-input
          v-model="domain"
          :state="$v.domain.$error? false : null"
          @input="$v.domain.$reset()"
          type="text"
          autocomplete="off"
        />
        <b-form-invalid-feedback>
          <div v-if="!$v.domain.required">To pole jest wymagane</div>
        </b-form-invalid-feedback>
      </b-form-group>

      <b-form-group class="required" label="Opis">
        <b-form-textarea
          v-model="description"
          :state="$v.description.$error? false : null"
          @input="$v.description.$reset()"
          rows="3"
          max-rows="6"
          autocomplete="off"
        />
        <b-form-invalid-feedback>
          <div v-if="!$v.description.required">To pole jest wymagane</div>
        </b-form-invalid-feedback>
      </b-form-group>
    </b-form>
  </b-modal>
</template>

<script>
// import { axios, eventBus } from "@/_infrastructure";
import { required } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      visible: false,
      title: null,
      domain: null,
      description: null
    };
  },
  computed: {
    modalTitle() {
      if (this.subject) {
        return "Edycja tematu";
      } else {
        return "Utwórz nowy temat";
      }
    }
  },
  props: ["subject"],
  validations: {
    title: { required },
    domain: { required },
    description: { required }
  },
  methods: {
    show() {
      this.visible = true;
    },
    onShow() {
      this.$v.$reset();

      if (this.subject) {
        this.title = this.subject.title;
        this.description = this.subject.description;
        this.domain = this.subject.domain;
      } else {
        this.title = null;
        this.description = null;
        this.domain = null;
      }
    },
    onOk(e) {
      e.preventDefault();
      this.onSubmit();
    },
    onSubmit() {
      this.$v.$touch();

      if (!this.$v.$error) {
        let result = {
          title: this.title,
          description: this.description,
          domain: this.domain
        };

        this.$emit("save", result);
        this.visible = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
</style>

